// @flow

import jsCookies from 'js-cookie';
export const TOKEN_KEY = 'token';

export function getKey() {
  return jsCookies.get(TOKEN_KEY);
}

export function setKey(key: string) {
  return jsCookies.set(TOKEN_KEY, key);
}

export function invalidateKey() {
  jsCookies.remove(TOKEN_KEY);
}



// WEBPACK FOOTER //
// ./js/util/session.js